<div class="payment-cancel">
  <div class="card">
    <div class="icon">❌</div>
    <h2>Payment Canceled</h2>
    <p>Your payment was not completed. Please try again later.</p>
    <!-- <button routerLink="/checkout" class="btn-retry">Try Again</button> -->
  </div>
</div>
